var stickySidebar = function () {
    if ($(window).width() > 576 && document.querySelector('.sticky-sidebar:not(.product-details):not(.blog-sidebar)')) {
        var stickySidebarInstance = new StickySidebar('.sticky-sidebar', {
            containerSelector: '.sticky-sidebar-container',
            innerWrapperSelector: '.sidebar-cart-wrapper',
            topSpacing: 20,
            bottomSpacing: 20,
            resizeSensor: true,
        });

        $.subscribe('/sticky-sidebar/update', function () {
            stickySidebarInstance.updateSticky();
        });
    }

};
App.prototype.pageDetector('sticky-sidebar', stickySidebar);

